export default {
  props: ['label','value','md','disabled','old_value','filter','chips','view_only','tag'],
  data() {
    return {
      model:null,
      old_value_removed_names: [],
      old_value_added_names: [],
    }
  },
  computed: {
    filteredItems(){ return this.items.filter(this.filter) },
    c_tag(){ return this.tag || (this.md?'v-flex':'div') },
  },
  watch: {
    'value'(v){ this.model=v },
    'model'(v){ this.$emit('update:value', v) },
    'old_value'(v){ v && this.set_old_names() },
  },
  created(){ 
    this.model=[undefined].includes(this.value)?null:this.value
    if (this.old_value) this.set_old_names();
  },
  methods:{
    set_old_names(){ // parte multiple
      if (!Array.isArray(this.old_value)) return;
      const r_ids = this.old_value.filter(i=>!this.value.includes(i));
      const a_ids = this.value.filter(i=>!this.old_value.includes(i));
      const v_r = this.items.filter(i=>r_ids.includes(i.id));
      const v_a = this.items.filter(i=>a_ids.includes(i.id));
      if (this.get_name) {
        this.old_value_removed_names = v_r.map(r=>this.get_name(r));
        this.old_value_added_names = v_a.map(r=>this.get_name(r));
      }
    }
  }
};
